/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import customStyles from "../../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import usePrevious from "../../../../Shared/components/Previous";
import { Row, Col, Image, Space } from "antd";
import { checkCRUDPermission, checkComponentPermission, capitalizeFirstLetter } from '../../../../../helpers/utilities';
import { TextField } from "@mui/material";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { ListTable } from './ListTable';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import crudActions from "../../../../CRUD/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

export const ScheduleList = React.forwardRef((props, ref) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { handleOpen, type, customerApi } = props;
    const [deleteModal, setDeleteModal] = useState(false);
    const [iconAnimation, setIconAnimation] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("serial_no");
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [search, setSearch] = useState('');
    const classes = customStyles();
    const dispatch = useDispatch();
    const prevSearch = usePrevious(search);
    const [scheduleId, setScheduleId] = useState('');
    const [name, setName] = useState('');
    const [customerId, setCustomerId] = useState('');
    const timeoutRef = useRef(null);

    const onDelete = (data) => {
        setDeleteModal(true);
        setScheduleId(data.id);
        setName(data.scheduleId);
    }

    useImperativeHandle(ref, () => ({
        dispatchFilter() {
            dispatchFilter(customerId, sortBy, sortOrder);
        }
    }))

    const customObject = (details, id) => {
        let a = details && details?.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const dispatchFilter = (customerId = '', sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (customerId) {
            filter['and'].push({ customerId: customerId });
        }

        if (search !== '') {
            or['or'].push({ schedule_status: { like: '%' + search.trim() + '%' } });
            or['or'].push({ serial_no: { like: '%' + search.trim() + '%' } });
        }

        filter['and'].push(or);

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'v1/schedule-instance/customer-schedule-instances/manual_list',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });
            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(customerId, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(customerId, sortBy, sortOrder, s);
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(customerId, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(customerId, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);


    const handleChangeCustomer = (value) => {
        setCustomerId(value);
        dispatchFilter(value, sortBy, sortOrder);
    }

    return <>
        <MainHeader {...props} img={SettingsImg}
            title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Schedule Transactions', 'link': '' }]} />
        <div className={clsx(classes.margin40, classes.listTableMargin)}>
            <PrimaryCard
                title={`Schedule Transactions`}
                component={
                    <>
                        <Row align="middle" className={classes.marginBottom20}>
                            <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                {
                                    roleManagement !== '' && checkComponentPermission(`Schedule Transactions`, 'Action', 'Search') &&
                                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                        <TextField autoComplete='one-time-code'
                                            placeholder={'Search Schedule ID and Status'}
                                            type='search'
                                            value={search}
                                            className={classes.comInput}
                                            required
                                            variant={'standard'}
                                            onChange={(e) => setSearch(e.target.value)}
                                            fullWidth
                                            onFocus={() => setIconAnimation(true)}
                                            onBlur={() => setIconAnimation(false)}
                                        />
                                        <Image src={SearchIcon} preview={false} />
                                        {
                                            search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                <Image
                                                    src={ClearIcon}
                                                    preview={false}
                                                />
                                            </NavLink>
                                        }
                                    </div>
                                }
                            </Col>
                            <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.customerLabelNone, classes.allCustomerTop)}>
                                <div className={classes.overlFlowResponsiveDesign}>
                                    <Space direction="horizontal" align="center">
                                        {
                                            roleManagement !== '' && checkComponentPermission('Schedule Transactions', 'Action', 'All Customer') &&
                                            <AutoCompleteComponent
                                                customLabel={"All Customers "}
                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                details={customerDetails}
                                                customClasses={classes.customWidth172P}
                                                position={"bottom"}
                                                variant={'outlined'}
                                                parentValue={customObject(customerDetails, customerId)}
                                                onChangeText={(data) => {
                                                    if (data === '') {
                                                        handleChangeCustomer(data);
                                                    }
                                                }}
                                                searchType={(s) => customerApi(s)}
                                                onChange={(data) => handleChangeCustomer(data.id)}
                                            />
                                        }
                                        {
                                            roleManagement !== '' && checkCRUDPermission(`Schedule Transactions`, 'create', 'Admin') &&
                                            <NavLink
                                                to={"#"}
                                                onClick={() => handleOpen(true)}
                                                className={clsx(classes.customLink)}>
                                                <Image
                                                    src={AddIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Run Schedule</span>
                                            </NavLink>
                                        }
                                    </Space>
                                </div>
                            </Col>
                        </Row>
                        <ListTable
                            type={type}
                            search={search}
                            onDelete={(data) => onDelete(data)}
                            loadTasks={() => dispatchFilter(customerId, sortBy, sortOrder)}
                            details={getList}
                            loadMore={loadMore}
                            {...props}
                            loadMoreTask={() => loadMoreTask()}
                            loadMoreContent={loadMoreContent}
                            sortOrder={sortOrder}
                            sortBy={sortBy}
                            roleManagement={roleManagement}
                            onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                        />
                    </>
                }
            />
        </div>
        <DeleteModal onClose={(v) => setDeleteModal(v)}
            id={scheduleId} loadTasks={() => dispatchFilter(customerId, sortBy, sortOrder)} name={name} url={'schedule'}
            title={capitalizeFirstLetter(type)} visible={deleteModal} />
    </>
})